module.exports = __webpack_public_path__ + "static/media/door-hints.803f676a.png";